<template>
  <div class="relative text-light-950 dark:text-dark-50">
    <select
      :id="id ? id : undefined"
      :required="isRequired"
      class="!outline-none w-full border border-charcoal-900/10 border-opacity-30 rounded-full font-medium bg-white dark:bg-dark-800 dark:border-dark-600 invalid:text-charcoal-500 appearance-none cursor-pointer"
      :class="[
        size === 'base' ? 'py-2 pl-3.5 pr-8 text-base' : '',
        size === 'sm' ? 'py-1 pl-2.5 pr-6 text-xs' : ''
      ]"
      :value="value"
      :autocomplete="autocomplete"
      v-bind="attrs"
      @keyup="onChange"
      @change="onChange"
    >
      <option v-if="placeholder" value="" disabled selected hidden>
        {{ placeholder }}
      </option>
      <option
        class="p-4"
        v-for="option in options"
        :value="option.value"
        :key="option.value"
        :disabled="option.isDisabled"
      >
        {{ option.label }}
      </option>
    </select>

    <div 
      class="bg-gradient-to-l from-white dark:from-dark-800 to-white/0 dark:to-dark-800/0 absolute top-0 h-full w-6 pointer-events-none rounded-r-full"
      :class="[
        size === 'base' ? 'right-8' : '',
        size === 'sm' ? 'right-6' : ''
      ]"
    />

    <IconBase
      name="cute/angle-right"
      :width:="size === 'base' ? 18 : 16"
      class="absolute rotate-90 top-1/2 -translate-y-1/2 pointer-events-none"
      :class="[
        size === 'base' ? 'right-2' : '',
        size === 'sm' ? 'right-1.5' : ''
      ]"
    />
  </div>
</template>

<script lang="ts" setup>
import { Ref } from '@/classes'

const props = withDefaults(defineProps<{
  id?: string
  modelValue: string | number
  autocomplete?: string
  isRequired?: boolean
  size?: 'sm' | 'base'
  options: {
    label: string
    value: string | number | boolean
    isDisabled?: boolean
  }[]
  placeholder?: string
  styleType?: 'base'
  attrs?: { [key: string]: string }
}>(), {
  id: '',
  size: 'base',
  isRequired: false,
  placeholder: '',
  styleType: 'base',
  options: () => [],
  attrs: () => ({})
})

const emit = defineEmits([ 'update:modelValue', 'update' ])

const { modelValue } = toRefs(props)

const value: Ref<Number | String> = ref('')
watch(modelValue, (v) => {
  nextTick(() => value.value = v)
}, { immediate: true })

const onChange = (e) => {
  emit('update:modelValue', getValue(e.target.value))
  emit('update', getValue(e.target.value))
}

const getValue = (value: string | number) => {
  if (value === 'true') return true
  if (value === 'false') return false
  
  return value
}
</script>